import styled from 'styled-components';

export const CallToActionButtonContainer = styled.button`
  font-family: var(--font-sans);
  font-size: 1rem;
  color: var(--color-white);

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 8px 16px;
  background-color: var(--color-dark-green);
  border: none;
  border-radius: 8px;

  &:hover {
    cursor: pointer;

    transition: 0.2s;
    background-color: var(--color-dark-green-hover);
  }

  &:active {
    transition: 0.1s;
    transition-timing-function: ease-out;
    transform: translateY(2px);
  }
`;
